import React, { Component } from 'react';
import Modal from 'js/components/global/Modal';

class BestPriceModalWrapper extends Component {
  state = {
    brandOptions: window._app.brandOptions
  }

  render() {
    const { title, phoneNumber, url } = this.state.brandOptions;
    const { context } = this.props;

    return (
      <Modal
        className="vw-vctn fok-title"
        isOpen={context.state.isModalOpen.bestPrice}
        onAfterOpen={this.afterOpenModal}
        onRequestClose={context.closeModal('bestPrice')}
        contentLabel="Best Price Guarantee Modal"
      >

        <h2 className="popup-title util-uppercase">The {title} Best Price Guarantee</h2>

        <p className="best-price-text">
          Our Best Price Guarantee allows you to feel certain that the room rate you receive
          is the best price for your { title } vacation. You can book with confidence online,
          through your favorite travel agent, or by calling <a className="bold-link" href={`tel:${phoneNumber}`}>{`1-888-${title.toUpperCase()}`}</a>.
        </p>

        <div className="row">
          <div className="sm-12 md-6">
            <p className="best-price-text best-price-fp">
              If within 24 hours of booking your online vacation at <a href={`https:${url}`} target="_blank"><u className="bold-link">{url.replace('//', '')}</u></a>,
              you find a lower price for the same arrival date, number of nights and room accommodations we will refund the difference.
            </p>
          </div>
          <div className="sm-12 md-6">
            <img className="modal-logo" src={`${window._app.cdnPath}logos/best-price/best-price-${title.toLowerCase()}.png`} />
          </div>
        </div>

      </Modal>
    );
  }
}

export default BestPriceModalWrapper;



// WEBPACK FOOTER //
// ./js/components/global/BestPriceModalWrapper.js